import React, { useEffect } from 'react'; // <-- Import useEffect
import HeroSection from './HeroSection/HeroSection';
import About from './About/About';
import Navbar from './Navbar/Navbar';
import Disturber from './Disturber/Disturber';
import Services from './Services/Services';
import Contact from './Contact/Contact';
import Cards from './Cards/Cards';
import WhatsAppButton from './WhatsAppButton/WhatsAppButton';
import './App.css';

function App() {
    // Set the document title using the useEffect hook
    useEffect(() => {
        document.title = "beabstracto";
    }, []); // Empty dependency array ensures this runs only once when component mounts

    return (
        <div className="App">
            <Navbar />
            <HeroSection />
            <About />
            <Cards />
            <Disturber />
            <Services />
            <Contact />
            <WhatsAppButton />
        </div>
    );
}

export default App;
